<div class="minclt-cascada-crumbbar" *ngIf="showBreadcrumbs && levels.length > 0">
  <ng-container *ngFor="let id of selectionState; let lvl = index">
    <ng-container *ngIf="id !== null && id !== undefined">
      <!-- <span class="cascada-crumb-arrow pi pi-angle-right" *ngIf="lvl > 0"></span> -->
      <span class="cascada-crumb">
        <span class="cascada-crumb-sw" [style.background]="colorOfLevel(lvl)"></span>
        {{ titleOfNode(nodeById(id), lvl) }}
      </span>
    </ng-container>
  </ng-container>
  <span class="cascada-crumb-empty" *ngIf="!hasSelection()">
    Ningún elemento seleccionado todavía
  </span>
</div>

<div class="px-7">
  <div class="minclt-cascada">
    <!-- Botón de navegación izquierda -->
    <button class="cascada-nav-btn cascada-nav-btn--left" [disabled]="!canScrollLeft" (click)="scrollLeft()"
      [pTooltip]="'Desplazar hacia la izquierda'" tooltipPosition="right" [attr.aria-label]="'Navegar a la izquierda'">
      <span class="pi pi-chevron-left"></span>
    </button>

    <!-- Botón de navegación derecha -->
    <button class="cascada-nav-btn cascada-nav-btn--right" [disabled]="!canScrollRight" (click)="scrollRight()"
      [pTooltip]="'Desplazar hacia la derecha'" tooltipPosition="left" [attr.aria-label]="'Navegar a la derecha'">
      <span class="pi pi-chevron-right"></span>
    </button>

    <div class="cascada-board" #cascadaBoard *ngIf="levels.length > 0; else emptyBoard">
      <div class="cascada-column" *ngFor="let level of levels; let lvl = index">
        <div class="cascada-col-head px-3 pb-3">
          <div class="flex gap-8 align-items-center justify-content-between w-full">
            <div class="cascada-col-title">
              <span class="cascada-col-sw" [style.background]="colorOfLevel(lvl)"></span>
              <span>{{ level.name }}</span>
            </div>

            <app-boton-svg *ngIf="parentSelected(lvl) && canCreate(lvl)" [id]="actionId('crear', lvl)"
              [nombre]="'agregar'" [color]="'verde-menta-oscuro'" [size]="'24'" [borderRadius]="'8'"
              [pTooltip]="'Agregar ' + level.name.toLowerCase()" tooltipPosition="top"
              (click)="onOptionalButtonClickHandler('crear', lvl, createPlaceholderNode(lvl))">
            </app-boton-svg>
          </div>


          <div class="cascada-col-filter">
            <input type="text" class="cascada-filter-input" placeholder="Buscar..." [value]="filterState[lvl] || ''"
              (input)="onFilterChange(lvl, $event)" [pTooltip]="'Filtrar ' + level.name.toLowerCase()"
              tooltipPosition="top" />
          </div>
        </div>

        <div class="cascada-col-list">
          <div class="cascada-empty" *ngIf="!parentSelected(lvl) || nodesOfLevel(lvl).length === 0">
            {{ emptyColumnMessage(lvl) }}
          </div>

          <div class="cascada-item" *ngFor="let node of nodesOfLevel(lvl)" [id]="itemId(lvl, node)"
            [class.selected]="isSelected(lvl, node.id)" [style.--sel-color]="colorOfLevel(lvl)"
            (click)="selectNode(lvl, node.id)">
            <div class="cascada-item-name">{{ titleOfNode(node, lvl) }}</div>
            <div class="cascada-item-meta" *ngIf="summaryOfNode(node, lvl)">{{ summaryOfNode(node, lvl) }}</div>

            <div class="cascada-item-actions">
              <ng-container *ngIf="extraItemActionTemplate" [ngTemplateOutlet]="extraItemActionTemplate"
                [ngTemplateOutletContext]="{ $implicit: node, level: lvl, selectNode: selectNodeFn }">
              </ng-container>

              <!-- Botones predeterminados ahora emiten a través de onOptionalButtonClick -->
              <app-boton-svg *ngIf="canDelete(lvl)" [id]="actionId('eliminar', lvl, node)" [nombre]="'eliminar'"
                [color]="'purpura-grisaceo'" [size]="'24'" [pTooltip]="'Eliminar'" tooltipPosition="top"
                (click)="$event.stopPropagation(); selectNode(lvl, node.id); onOptionalButtonClickHandler('eliminar', lvl, node)">
              </app-boton-svg>
              <app-boton-svg *ngIf="canEdit(lvl)" [id]="actionId('editar', lvl, node)" [nombre]="'editar'"
                [color]="'purpura-grisaceo-inv'" [size]="'24'" [pTooltip]="'Editar'" tooltipPosition="top"
                (click)="$event.stopPropagation(); selectNode(lvl, node.id); onOptionalButtonClickHandler('editar', lvl, node)">
              </app-boton-svg>
              <app-boton-svg *ngIf="canView(lvl)" [id]="actionId('ver', lvl, node)" [nombre]="'ver-contenido'"
                [color]="'purpura-grisaceo-inv'" [size]="'24'" [pTooltip]="'Ver ficha completa'" tooltipPosition="top"
                (click)="$event.stopPropagation(); selectNode(lvl, node.id); onOptionalButtonClickHandler('ver', lvl, node)">
              </app-boton-svg>

              <app-boton-svg *ngIf="canShowButton(lvl, 'configuracion')" [id]="actionId('configuracion', lvl, node)"
                [nombre]="'configuracion'" [color]="'purpura-grisaceo-inv'" [size]="'24'" [pTooltip]="'Configurar'"
                tooltipPosition="top"
                (click)="$event.stopPropagation(); selectNode(lvl, node.id); onOptionalButtonClickHandler('configuracion', lvl, node)">
              </app-boton-svg>

              <app-boton-svg *ngIf="canShowButton(lvl, 'indicador-informacion')"
                [id]="actionId('indicador-informacion', lvl, node)" [nombre]="'indicador-informacion'"
                [color]="'purpura-grisaceo-inv'" [size]="'24'" [pTooltip]="'Ver información del indicador'" tooltipPosition="top"
                (click)="$event.stopPropagation(); selectNode(lvl, node.id); onOptionalButtonClickHandler('indicador-informacion', lvl, node)">
              </app-boton-svg>

              <app-boton-svg *ngIf="canShowButton(lvl, 'enviar')" [id]="actionId('enviar', lvl, node)"
                [nombre]="'enviar'" [color]="'purpura-grisaceo-inv'" [size]="'24'" [pTooltip]="'Enviar a revisión'" tooltipPosition="top"
                (click)="$event.stopPropagation(); selectNode(lvl, node.id); onOptionalButtonClickHandler('enviar', lvl, node)">
              </app-boton-svg>

              <app-boton-svg *ngIf="canShowButton(lvl, 'enviar-todo')" [id]="actionId('enviar-todo', lvl, node)"
                [nombre]="'enviar-todo'" [color]="'purpura-grisaceo-inv'" [size]="'24'" [pTooltip]="'Enviar todo a revisión'" tooltipPosition="top"
                (click)="$event.stopPropagation(); selectNode(lvl, node.id); onOptionalButtonClickHandler('enviar-todo', lvl, node)">
              </app-boton-svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #emptyBoard>
      <div class="cascada-empty-board">{{ emptyBoardMessage }}</div>
    </ng-template>
  </div>
</div>